import React, { useState } from "react";
import styled from "styled-components";
import tw from "twin.macro"; // eslint-disable-next-line
import css from "styled-components/macro";
import { SectionHeading } from "components/misc/Headings.js";
import defaultCardImage from "../../images/shield-icon.svg";
import ReactModalAdapter from "../../helpers/ReactModalAdapter.js";
import { ReactComponent as CloseIcon } from "feather-icons/dist/icons/x.svg";
import { ReactComponent as SvgDecoratorBlob3 } from "../../images/svg-decorator-blob-3.svg";
import { PrimaryButton } from "components/misc/Buttons.js";
import { IoIosCall } from "react-icons/io";
import ACoupleOfLocks from "../../images/keyservice/acoupleoflocks.avif";

const Container = tw.div`-mx-8 px-8 relative bg-white`;

const ThreeColumnContainer = styled.div`
  ${tw`flex flex-col items-center md:items-stretch md:flex-row flex-wrap md:justify-center max-w-screen-xl mx-auto py-20 md:py-24`}
`;

const Heading = tw(SectionHeading)`w-full text-[#3F62A3]`;

const Column = styled.div`
  ${tw`md:w-1/2 lg:w-1/3 px-6 flex`}
`;

const Card = styled.div`
  ${tw`flex flex-col mx-auto max-w-xs items-center px-6 py-10 border-2 border-[#3F62A3] rounded-full mt-12 bg-white shadow-md transition duration-300 hover:shadow-lg`}
  .imageContainer {
    ${tw`border border-[#3F62A3] bg-[#f8faff] text-center rounded-full p-6 flex-shrink-0 relative`}
    img {
      ${tw`w-8 h-8`}
    }
  }

  .textContainer {
    ${tw`mt-6 text-center`}
  }

  .title {
    ${tw`mt-2 font-bold text-xl leading-none text-[#3F62A3]`}
  }

  .description {
    ${tw`mt-3 font-medium text-gray-600 text-sm leading-relaxed`}
  }
`;

const DecoratorBlob = styled(SvgDecoratorBlob3)`
  ${tw`pointer-events-none absolute right-0 bottom-0 w-64 opacity-25 transform translate-x-32 translate-y-48 text-[#3F62A3]`}
`;

const StyledModal = styled(ReactModalAdapter)`
  &.mainHeroModal__overlay {
    ${tw`fixed inset-0 z-50`}
  }
  &.mainHeroModal__content {
    ${tw`xl:mx-auto m-4 sm:m-16 max-w-screen-xl absolute inset-0 flex justify-center items-center rounded-lg bg-gray-100 outline-none`}
  }
  .content {
    ${tw`w-full xl:mx-0 mx-8 lg:p-16`}
  }
`;

const CloseModalButton = tw.button`absolute top-0 right-0 mt-8 mr-8 focus:text-[#3F62A3]`;
const Description = tw.p`mt-4 text-center mx-auto text-sm md:text-base lg:text-lg font-medium leading-relaxed text-black max-w-2xl`;

export default () => {
  const cards = [
    {
      title: "Sloten vervangen",
      description: "Onze monteurs vervangen oude of beschadigde sloten snel en professioneel, met gebruik van SKG-gecertificeerde producten.",
      fullDescription:
        "Bij Safety Locks vervangen we sloten zorgvuldig en met gecertificeerde materialen. Of het nu gaat om slijtage, verlies van sleutels of een upgrade van je beveiliging, wij zorgen voor een betrouwbare en veilige installatie die voldoet aan de hoogste kwaliteitseisen.",
      imageSource: ACoupleOfLocks,
    },
    {
      title: "24/7 noodservice",
      description: "Altijd bereikbaar bij buitensluiting of nood. Onze specialisten staan dag en nacht klaar.",
      fullDescription:
        "Buitengesloten? Sleutel afgebroken? Onze 24/7 noodservice is binnen korte tijd ter plaatse. Wij openen je deur zonder schade en zorgen dat je snel weer veilig binnen bent. Altijd bereikbaar, altijd professioneel.",
      imageSource: ACoupleOfLocks,
    },
    {
      title: "Driepuntssluitingen",
      description: "Voor maximale veiligheid installeren wij driepuntssluitingen op maat, inclusief montage en afstelling.",
      fullDescription:
        "Een driepuntssluiting biedt extra beveiliging door de deur op meerdere punten te vergrendelen. Wij installeren deze systemen volgens de laatste veiligheidsnormen, voor optimale bescherming tegen inbraakpogingen.",
      imageSource: ACoupleOfLocks,
    },
    {
      title: "Inbraakpreventie",
      description: "Voorkom inbraak met onze preventieve beveiligingsoplossingen en deskundig advies.",
      fullDescription:
        "Onze experts analyseren jouw woning of bedrijfspand en adviseren over effectieve beveiligingsmaatregelen. Denk aan kerntrekbeveiliging, anti-inbraakstrips en stevige bijzetsloten. Alles voor jouw gemoedsrust.",
      imageSource: ACoupleOfLocks,
    },
    {
      title: "Sleutels bijmaken",
      description: "Snelle en nauwkeurige duplicatie van sleutels, inclusief veiligheidssleutels.",
      fullDescription:
        "Wij maken kopieën van bijna alle soorten sleutels, met moderne apparatuur en maximale precisie. Zo heb je altijd een extra sleutel bij de hand, veilig en betrouwbaar.",
      imageSource: ACoupleOfLocks,
    },
    {
      title: "Extra sloten plaatsen",
      description: "Versterk je beveiliging met extra sloten en bijzetsloten, professioneel gemonteerd.",
      fullDescription:
        "Wil je je deuren extra beveiligen? Wij plaatsen hoogwaardige cilinder- of bijzetsloten die extra weerstand bieden bij inbraakpogingen. Perfect afgestemd op jouw type deur en bestaande sluitwerk.",
      imageSource: ACoupleOfLocks,
    },
  ];

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);

  const toggleModal = (index) => {
    setSelectedCard(index);
    setModalIsOpen(!modalIsOpen);
  };

  return (
    <Container id="diensten">
        <Heading>
          Onze <span tw="text-primary-500">diensten</span>
        </Heading>
        <Description>
          Veiligheid begint bij degelijk vakmanschap. Safety Locks biedt een breed scala aan slotenmakersdiensten
          door gecertificeerde specialisten. Staat je gewenste service er niet tussen? Neem gerust contact met ons op,
          we denken graag met je mee.
        </Description>
      <ThreeColumnContainer>
        {cards.map((card, i) => (
          <Column key={i}>
            <Card>
              <span className="imageContainer">
                <img src={card.imageSrc || defaultCardImage} alt="" />
              </span>
              <span className="textContainer">
                <span className="title">{card.title}</span>
                <p className="description">{card.description}</p>
              </span>
              <PrimaryButton onClick={() => toggleModal(i)} tw="mt-5 mr-0! bg-[#3F62A3] text-white hover:bg-[#2d4b7a]">
                Meer info
              </PrimaryButton>
            </Card>
          </Column>
        ))}
      </ThreeColumnContainer>

      <DecoratorBlob />

      <StyledModal
        closeTimeoutMS={300}
        className="mainHeroModal"
        isOpen={modalIsOpen}
        onRequestClose={toggleModal}
        shouldCloseOnOverlayClick={true}
      >
        <CloseModalButton onClick={toggleModal}>
          <CloseIcon tw="w-6 h-6" />
        </CloseModalButton>
        <div className="content" tw="w-full xl:mx-0 mx-8 lg:p-16">
          {selectedCard !== null && cards[selectedCard] && (
            <div tw="flex flex-col lg:flex-row items-center lg:items-start justify-between">
              <div tw="lg:w-1/2 flex-shrink-0 mb-6 lg:mb-0">
                <img
                  src={cards[selectedCard].imageSource}
                  alt={cards[selectedCard].title}
                  tw="rounded-lg shadow-lg w-full h-full object-cover"
                />
              </div>
              <div tw="lg:w-1/2 lg:pl-10 flex flex-col items-center lg:items-start">
                <h2 tw="text-3xl font-extrabold text-[#3F62A3] mb-4 text-center lg:text-left">
                  {cards[selectedCard].title}
                </h2>
                <p tw="text-base lg:text-lg text-gray-700 leading-relaxed mb-6">
                  {cards[selectedCard].fullDescription}
                </p>
                <a href="tel:nvt" className="text-sm">
                  <PrimaryButton className="flex bg-[#3F62A3] hover:bg-[#2d4b7a]">
                    <IoIosCall className="mr-2 mt-1" />
                    nvt
                  </PrimaryButton>
                </a>
              </div>
            </div>
          )}
        </div>
      </StyledModal>
    </Container>
  );
};
